import { Filter } from "../interfaces/filter";

export const Filters: Filter[] = [

    { db_key: "pct_supportlevel", display_key: "Supportlevel", options: ["1", "2", "3"] , displayed: true},
    { db_key: "pct_status", display_key: "Status", options: ["open", "closed"]  , displayed: true},
    { db_key: "pct_has_solution", display_key: "Has solution", options: ["true", "false"]  , displayed: true},
    { db_key: "updatedAt[$gte]", display_key: "Start", options: [""]  , displayed: false},
    { db_key: "updatedAt[$lte]", display_key: "End", options: [""]  , displayed: false},
    { db_key: "pct_countrycode", display_key: "Country", options: [""], displayed: true, customFilter: true},
    { db_key: "pct_organization", display_key: "Organization", options: [], displayed:true }
]


